<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">

      <maintenance-bar v-if="maintenance"/>

      <vx-card>
        <div class="full-page-bg-color" slot="no-body">

          <vs-row vs-type="flex" vs-w="12">

            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12" vs-lg="6">
              <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8" vs-lg="6">
                  <img alt="login" class="mx-auto" src="@/assets/images/pages/login/image.svg" style="width:100%;">
                </vs-col>
              </vs-row>
            </vs-col>

            <div class="vx-col flex sm:w-1 md:w-1 lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Reset password</h4>
                </div>

                <div class="pt-2">
                  <form autocomplete="on">

                    <vs-input
                      class="w-full mt-6"
                      icon="icon icon-lock"
                      icon-no-border
                      icon-pack="feather"
                      label-placeholder="Password"
                      ref="password"
                      name="password"
                      type="password"
                      v-on:input="clearErrorMessage"
                      v-model="password"
                      autocomplete="on"
                      v-validate="{ required: true, min: 10, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&,:;<>~_=\*\.\$\^\(\)\{\}\[\]\?\+\-\|\/\\]).{10,60}/ }"
                      :danger="errors.has('password')"
                      :danger-text="errors.first('password')"

                    />

                    <vs-input
                      class="w-full mt-6"
                      icon="icon icon-lock"
                      icon-no-border
                      icon-pack="feather"
                      label-placeholder="Password Confirmation"
                      ref="password-confirmation"
                      name="password-confirmation"
                      type="password"
                      v-on:input="clearErrorMessage"
                      v-model="passwordConfirmation"
                      autocomplete="on"
                      v-validate="'required|confirmed:password'"
                      data-vv-as="password"
                      :danger="errors.has('password-confirmation')"
                      :danger-text="errors.first('password-confirmation')"
                    />
                  </form>

                  <vs-alert color="danger" :active="errorMessage" class="mt-5 mb-5">
                    Changing your password cannot be done. Please contact your referrent manager.
                  </vs-alert>
                  <vs-alert color="danger" :active="errorMessageDoesntMatch" class="mt-5 mb-5">
                    The password confirmation does not match
                  </vs-alert>
                  <vs-alert :active="!errorMessage && this.$route.query.reset_key" class="mt-5 mb-5">
                    Please enter your new password and confirmation to change it.
                  </vs-alert>
                  <vs-alert color="warning" :active="!errorMessage && !this.$route.query.reset_key" class="mt-5 mb-5">
                    The link you clicked on to access this page is invalid.
                  </vs-alert>

                  <vs-button class="float-right mb-5 mt-5" @click="onSubmit"
                             :disabled="!this.$route.query.reset_key || errors.any() || !isFormDirty">Change password
                  </vs-button>
                  <vs-button class="float-right mb-5 mt-5" type="flat" @click="onCancel">Cancel</vs-button>
                </div>
              </div>
            </div>
          </vs-row>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import {Auth} from 'aws-amplify';
import MaintenanceBar from '@/layouts/components/navbar/components/maintenance-bar';

/* eslint-disable security/detect-object-injection */
export default {
  components: {MaintenanceBar},
  props: {
    publicRoot: {
      type: ResourceImpl,
      required: true
    }
  },
  data () {
    return {
      password: '',
      passwordConfirmation: '',
      errorMessage: false,
      errorMessageDoesntMatch: false
    };
  },
  computed: {
    isFormDirty () {
      return ['password', 'password-confirmation'].every(key => this.fields[key] && this.fields[key].dirty);
    },
    maintenance () {
      return this.$store.state.maintenance.maintenance;
    }
  },
  mounted () {
    const dict = {
      custom: {
        password: {
          regex: 'Min. 10 characters with uppercase, lowercase, a number and a special character.'
        }
      }
    };

    this.$validator.localize('en', dict);
  },
  methods: {
    onCancel () {
      this.$router.push({
        name: 'page-login'
      });
    },
    clearErrorMessage () {
      if (this.errorMessageDoesntMatch) {
        this.errorMessageDoesntMatch = false;
      }
    },
    onSubmit () {
      if (this.password !== this.passwordConfirmation) {
        this.errorMessageDoesntMatch = true;
        return;
      }

      this.loading = true;
      this.publicRoot.$request().$post('prepare_cognito', null, {
        token: this.$route.query.reset_key
      }).then(res => {
        if (this.$route.query.code) {
          Auth.forgotPasswordSubmit(res.userName, this.$route.query.code, this.password)
            .then(() => {
              this.$router.push({
                name: 'page-login'
              });
            })
            .catch(err => {
              this.error = !!err;
            }).finally(() => {
              this.loading = false;
            });
        } else {
          this.errorMessage = false;
          this.$vs.loading({});
          this.publicRoot.$request().$post('reset-password', null, {
            token: this.$route.query.reset_key,
            password: this.password,
            passwordConfirmation: this.passwordConfirmation
          }).then(() => {
            this.$vs.notify({
              title: 'Password changed',
              text: 'Your account password has been changed. You can now sign in.',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            });
            this.$router.push({
              name: 'page-login'
            });
          }, err => {
            this.$log.debug(err);
            this.errorMessage = true;
          }).finally(() => {
            this.$vs.loading.close();
          });
        }
      }).catch(err => {
        this.$log.debug(err);
        this.errorMessage = true;
      }).finally(() => {
        this.$vs.loading.close();
      });
    }
  }
};
</script>
